export default __webpack_public_path__ + "static/media/di.affa1de4.png";